import styled from "styled-components";

export default styled.div`
  white-space: pre;
`

/*
    This is to stop cyclic dependencies - I know it's horrible
 */